/* global __VERSION__ */
import Raven from 'raven-js';
import RavenMiddleware from 'redux-raven-middleware';

// Enable Raven only in production and staging environments.
const RAVEN_DSN = (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging')
  ? 'https://a160a3accd7a4871afebe82906425cdb@o300203.ingest.sentry.io/4505588323909632'
  : '';
  
Raven.config(RAVEN_DSN, {
  release: __VERSION__,
  environment: process.env.NODE_ENV,
  user: localStorage.getItem('username') || 'anonymous',
}).install();

export const ravenMiddleware = RavenMiddleware(RAVEN_DSN);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/raven.js